import { render } from "./SmartButton.vue?vue&type=template&id=8676d924&lang=pug"
import script from "./SmartButton.vue?vue&type=script&lang=js"
export * from "./SmartButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__